<template>
  <b-container>
    <img class="avatar" alt="Avatar" :src="src" :style="widthStyle" />
  </b-container>
</template>

<script>
export default {
  name: "Avatar",
  props: {
    avatar: {
      type: String,
      default: null
    },
    width: {
      type: Number,
      default: 150
    }
  },
  computed: {
    src() {
      return this.avatar ? this.avatar : require("../assets/svg/avatar.svg");
    },
    widthStyle() {
      return {
        width: this.width + "em"
      };
    }
  }
};
</script>

<style scoped>
.avatar {
  height: auto;
  border-radius: 50%;
}
</style>
